<template>
  <div class="card-page-container mdl-shadow--2dp">
    <div class="mdl-card fill">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{'admin.labels.title.label' | label}}</h2>
      </div>
      <div class="mdl-card__supporting-text fill">
        <div class="mdl-grid inner-grid">
          <div class="mdl-cell mdl-cell--6-col">
            {{ 'admin.labels.filters.label' | label }}
          </div>
          <div class="mdl-cell mdl-cell--3-col">
            <option-select name="defaultPage" :value.sync="selectedPage" options="LABEL_SEGMENT" :preselected="selectedPage"></option-select>
          </div>
          <div class="mdl-cell mdl-cell--3-col">
            <option-select name="defaultLang" :value.sync="selectedLang" options="LANG" :preselected="selectedLang"></option-select>
          </div>
        </div>
        <div v-for="type in labelTypes" class="">

          <div v-if="labels[type.value]" class="mdl-card fill">
            <div class="mdl-card__title">
              <div class="">{{ type.label | label }}</div>
            </div>
            <div v-show="!type.collapsed">
              <div class="mdl-card__supporting-text fill">
                <div v-for="label in labels[type.value]" class="listing mdl-grid mdl-grid--no-spacing"
                    :style="{ backgroundColor: labels[type.value].indexOf(label) % 2 === 1 ? '#F9F9F9' : '#FFF' }">
                  <div class="mdl-cell mdl-cell--6-col">
                    <div class="default" tooltip="{{label.key}}" effect="light"><span style="font-size:smaller">({{label.key}})&nbsp;</span>{{{ label.defaultText || label.key }}}</div>
                  </div>
                  <div class="mdl-cell mdl-cell--6-col">
                    <div v-if="type.value !== 'text'" class="profile-textfield mdl-textfield mdl-js-textfield fill">
                      <input class="mdl-textfield__input" type="text" id="{{label.key}}-input" v-model="label['text']">
                      <label class="mdl-textfield__label" for="{{label.key}}-input">{{'admin.labels.translation.label' | label}}</label>
                    </div>
                    <div v-if="type.value === 'text'" class="profile-textfield mdl-textfield mdl-js-textfield fill">
                      <text-area :body.sync="label['text']" :placeholder="getLabel('admin.labels.translation.label')" :component-id="getQuillId(label['key'])"></text-area>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mdl-card__menu">
              <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
                v-show="!type.collapsed"
                v-on:click="type.collapsed = true">
                <i class="material-icons">keyboard_arrow_up</i>
              </button>
              <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
                v-show="type.collapsed"
                v-on:click="type.collapsed = false">
                <i class="material-icons">keyboard_arrow_down</i>
              </button>
            </div>
          </div>


        </div>
      </div>
      <div class="mdl-card__actions">
        <div class="card-grid mdl-grid">
          <div class="mdl-cell mdl-cell--6-col">
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="submit-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
              v-on:click="save">
              {{'admin.labels.save.button' | label}}
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  var api = require('api')
  var label = require('vue').filter('label')
  var lookup = require('vue').filter('lookup')
  module.exports = {
    ready: function () {
      var self = this
      this.labelTypes = lookup('LABEL_TYPE').map(function (type) {
        type.collapsed = false
        return type
      })
      api.AppConfig.get().then(function (response) {
        var config = response.data
        self.defaultLang = config.defaultLang
        self.change({
          lang: self.selectedLang,
          type: self.selectedPage
        })
      }, self.onError)
    },
    components: {
      parametersForm: require('a/forms/ParametersForm'),
      optionSelect: require('c/components/Select'),
      'text-area': require('c/components/TextArea')
    },
    methods: {
      change: function (query) {
        var self = this
        api.Label.get({
          lang: this.defaultLang,
          type: query.type
        }).then(function (defaultResp) {
          console.log('here')
          api.Label.get(query).then(function (selectedResp) {
            var selectedIndex = selectedResp.data.reduce(function (prev, cur) {
              prev[cur.key] = cur
              return prev
            }, {})
            self.labels = defaultResp.data.map(function (defaultLabel) {
              var label = {}
              var selectedLangLabel = selectedIndex[defaultLabel.key] || {}
              label.key = defaultLabel.key
              label.id = selectedLangLabel.id || undefined
              label.defaultText = defaultLabel.text
              label.defaultText = label.defaultText.trim() || 'empty for key: ' + defaultLabel.key
              label.text = selectedLangLabel.text || ''
              label.langCode = self.selectedLang
              return label
            }).sort(function (a, b) {
              if (a.key < b.key) {
                return -1
              }
              if (a.key > b.key) {
                return 1
              }
              return 0
            }).reduce(function (prev, curr) {
              var type = self.findType(curr)
              prev[type] = prev[type] || []
              prev[type].push(curr)
              return prev
            }, {})
            self.$nextTick(function () {
              window.componentHandler.upgradeAllRegistered()
            })
          }, self.onError)
        }, self.onError)
      },
      findType: function (label) {
        var res = 'other'
        console.log(label)
        this.labelTypes.forEach(function (type) {
          var prefix = '.'
          // WRONG! if (type.value.indexOf('mail.' > -1)) {
          if (type.value.indexOf('mail.') > -1) {
            prefix = ''
          }
          if (label.key.indexOf(prefix + type.value) > -1) {
            res = type.value
          }
        })
        return res
      },
      getLabel: function (key) {
        return label(key)
      },
      save: function () {
        var self = this
        api.Label.bulkUpdate({}, JSON.stringify(this.flatten(this.labels)))
          .then(this.onSuccess, function () {
            self.$dispatch('show-error', {
              message: 'admin.labels.error.label'
            })
          })
      },
      flatten: function (labels) {
        var result = []
        Object.keys(labels).forEach(function (key) {
          labels[key].forEach(function (label) {
            result.push(label)
          })
        })
        return result
      },
      onSuccess: function () {
        this.$dispatch('loading', false)
        this.$dispatch('show-success', 'admin.labels.success.label')
      },
      onError: function (err) {
        this.$dispatch('loading', false)
        this.$dispatch('show-error', err)
      },
      getQuillId: function (key) {
        return key.replace(/\./gi, '')
      }
    },
    watch: {
      selectedPage: function (newVal) {
        this.change({
          lang: this.selectedLang,
          type: newVal
        })
      },
      selectedLang: function (newVal) {
        this.change({
          lang: newVal,
          type: this.selectedPage
        })
      }
    },
    data: function () {
      return {
        defaultLang: '',
        selectedPage: 'general',
        selectedLang: 'it',
        labels: {},
        labelTypes: []
      }
    }
  }
</script>

<style>
.profile-textfield {
  margin: -10px 0 -20px 0;
}
.listing .default {
  margin-top: 10px;
}
.listing .mdl-cell {
  padding: 0 10px 0 10px;
}
[tooltip] {
   position: relative;
}
[tooltip]::after, [tooltip]::before {
  position: absolute;
  z-index: 10;
  top: 10px;
  left: 20px;
  
  opacity: 0; /* display: none/block, transition will not occur */
  transition: opacity 0.3s ease;
  pointer-events: none;
}

[tooltip]::after {   /* tooltip box */
  content: attr(tooltip); /*  1. attr() get tooltip attr and set value */
  /* max-width: 200px; */
  padding: 8px 15px;
  border-radius: 4px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  border: 1px solid #f19100;
  background-color: white;
  color: #424242;
}

[tooltip]::before{ /*  tooltip arrow */
  content: '';
  border: 5px solid transparent;
  border-top-color: #f19100;
}

[tooltip]:hover::after, [tooltip]:hover::before { /* mouseenter, mouseleave */
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// Labels.vue?215ad754